import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentoAllegato } from '../../../models/documento-allegato';


@Component({
    selector: '[lista_documenti_di_sezione]',
  templateUrl: 'lista-documenti-di-sezione.component.html'
})

export class ListaDocumentiDiSezioneComponent {
  @Input()
  writable: boolean;

  @Output()
  onClickUpdateDocVersion = new EventEmitter();

  @Output()
  onClickShowVersionHistory = new EventEmitter();

  @Output()
  onClickAddDocument = new EventEmitter();

  @Output()
  onClickRemoveDocument = new EventEmitter();

  @Output()
  onClickUpdateMetadatiModal = new EventEmitter();

  @Output()
  onReturnUpdate = new EventEmitter();

  @Input()
  sezione: any;

  @Input()
  sezioni: Array<any>;

  @Input()
  fascicolo: any;

  @Input()
  addDocFormTitles: Array<string>;

  showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.onClickUpdateDocVersion.emit(documento);
  }

  showHistoryModal(documento: DocumentoAllegato) {
    this.onClickShowVersionHistory.emit(documento);
  }

  showAddDocModal(nomeCampoId) {
    console.log(nomeCampoId);
    this.onClickAddDocument.emit(this.addDocFormTitles[nomeCampoId]);
  }

  showUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.onClickUpdateMetadatiModal.emit(documento);
  }

  removeDoc(documento: DocumentoAllegato) {
    this.onClickRemoveDocument.emit(documento);
  }

  onReturnUpdateCallback(response) {
    this.onReturnUpdate.emit(response);
  }
}
